import { Button, Label, Modal, SelectSearch } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { ModalBulkKamProps } from './modal-bulk-kam.type'

import styles from './modal-bulk-kam.module.css'
import { useValidationErrors } from '@/helpers'
import { schema } from './modal-bulk-kam.constant'

export const ModalBulkKam = ({
  isOpen,
  onClose,
  kams = [],
  isLoadingKams = false,
  setSearchKams = () => {},
  selectedKam,
  setSelectedKam = () => {},
  onSubmit = () => {},
  isLoadingSubmit = false,
}: ModalBulkKamProps) => {
  const { t } = useTranslation('screenProfileShow')

  const { isValid, errors, onHandleListenErrors } = useValidationErrors(
    schema(t),
    {
      kam: selectedKam?.value,
    },
  )

  const onSubmitHandler = () => {
    if (!isValid) {
      return onHandleListenErrors(true)
    }

    onHandleListenErrors(false)
    onSubmit()
  }

  return (
    <Modal.Root isOpen={isOpen} onHandleOpen={onClose} size="medium">
      <Modal.Header
        title={t('modalBuilkKamTitle')}
        description={t('modalBuilkKamDescription')}
      />
      <Modal.Body className={styles['modal-body']}>
        <div>
          <Label>{t('modalBuilkKamLabel')}</Label>
          <SelectSearch<{ label: string; value: string }>
            dataSearch={kams}
            isLoadingSearch={isLoadingKams}
            onSearch={setSearchKams}
            onSelectItem={({ label = '', value = '' }) => {
              setSelectedKam({ label, value })
            }}
            selectedItem={selectedKam}
            translations={{
              inputSearchPlaceholder: t('modalBuilkKamPlaceholder'),
              noResults: t('modalBuilkKamNoResults'),
            }}
            error={errors?.kam ? (errors.kam as string) : undefined}
          />
        </div>
        <div className={styles['modal-footer']}>
          <Button variant="secondary" onClick={onClose}>
            {t('modalBuilkKamCancelButton')}
          </Button>
          <Button
            variant="primary"
            onClick={onSubmitHandler}
            disabled={isLoadingSubmit}
            isActive={!isLoadingSubmit}
          >
            {t('modalBuilkKamConfirmButton')}
          </Button>
        </div>
      </Modal.Body>
    </Modal.Root>
  )
}
